import http from './httpService';

export async function getAllCostCategory() {
	return await http.get('/CostCategory');
}

export default { getAllCostCategory };
